import axios            from 'axios';
import authHeader       from 'services/auth-header';

class MedicalCertificateService  {

  toggleMc(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'chat_sessions/' + id + '/toggle_mc', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  submitMedicalCertificate(params) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'medical_certificates', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  getMedicalCertificate(id){
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `medical_certificates/${id}?is_doctor=1`, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  sendEmail(id, params) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + `medical_certificates/${id}/send_email`, params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

}

export default new MedicalCertificateService();